import { makeAutoObservable } from 'mobx';
import { createContext } from 'react';

class SearchManager {
  public searchTerm?: string;

  constructor() {
    makeAutoObservable(this);
  }

  public setSearchTerm = (searchTerm: string) => {
    this.searchTerm = searchTerm;
  };

  public clearSearch = () => {
    this.searchTerm = undefined;
  };
}

export const SearchStore = new SearchManager();

const SearchContext = createContext(SearchStore);

export default SearchContext;
